import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import Icon from 'modules/react/components/stateless/Icon';
import style from './ViewLive.scss';

const propTypes = {
  live: PropTypes.bool.isRequired,
  disableEnUsPage: PropTypes.bool.isRequired,
  path: PropTypes.string.isRequired,
  metadata: PropTypes.shape({
    slug: PropTypes.string,
    linkOut: PropTypes.string,
  }).isRequired,
};

const ViewLive = ({
  path, live, metadata: { linkOut, type }, disableEnUsPage,
}) => {
  const link = path || linkOut;
  const viewLive = live && type !== 'voyager/pages/types/FACILITY_LISTING';
  const message = type === 'voyager/pages/types/FACILITY_LISTING' ? 'Facility Listing' : 'Page is not live';
  const statusMessage = disableEnUsPage ? 'Page is disabled' : message;

  return (
    <div>
      {viewLive && !disableEnUsPage ?
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className={`${style.viewIcon} ${style.size25SVG}`}
        >
          <Icon id="eye-with-pupil" label="view live" />
        </a> :
        <OverlayTrigger
          overlay={
            <Popover
              id="popover-basic"
              className={style.customPopover}
            >
              {statusMessage}
            </Popover>
          }
          placement="left"
        >
          <div className={`${style.viewIconDisabled} ${style.size25SVG}`}>
            <Icon id="eye-slash" label="view live" />
          </div>
        </OverlayTrigger>
      }
    </div>
  );
};

ViewLive.propTypes = propTypes;

export default ViewLive;
